enum HousingType {
  Ownership = 'ownership',
  Rental = 'rental',
  Shared = 'shared',
  Parental = 'parental',
}

export default HousingType;
